import { Injectable, inject } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { RouterStateSnapshot, TitleStrategy } from '@angular/router';

import { AppConfig } from '®shared/config/app-config';

@Injectable({ providedIn: 'root' })
export class CustomTitleStrategy extends TitleStrategy {
  private readonly titleService = inject(Title);
  private readonly appConfig = inject(AppConfig);

  override updateTitle(routerState: RouterStateSnapshot): void {
    const title = this.buildTitle(routerState);
    const appName = this.appConfig.tenant.applicationName;

    if (title) {
      this.titleService.setTitle(title + ' - ' + appName);
    }
  }
}
